/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import "zone.js"; // Included with Angular CLI.
import packageInfo from "../../package.json";
import { LoonEnvironment, LoonEnvironmentFactory, LoonEnvironmentName } from "./loon.environment";
import { AuthConfig } from "angular-oauth2-oidc";
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const urlRoot = "//add-editdev.northstarmls.com/";
const fileSystem = "//mediadev.northstarmls.com/";
const oAuth: AuthConfig = {
	issuer: "https://signin-dev.northstarmls.com",
	redirectUri: window.location.origin + "/auth-callback",
	postLogoutRedirectUri: window.location.origin,
	clientId: "api.addedit.testing",
	tokenEndpoint: "https://signin-dev.northstarmls.com/connect/token",
	silentRefreshRedirectUri: window.location.origin + "/silent-refresh.html",
	scope: "openid profile recorememberprofile offline_access coredataapi",
};

export const environment: LoonEnvironment = LoonEnvironmentFactory(
	LoonEnvironmentName.DEV,
	false,
	packageInfo.version,
	urlRoot,
	oAuth,
	fileSystem,
	"G-YVJJQ35ZJ6",
	{
		pendo: {
			apiKey: "6ef2b7da-a116-4a16-a431-8c0327119b94",
		},
	}
);

// export const environment: LoonEnvironment = {
//   name: 'DEV',
//   production: false,
//   version,
//   endpoints: {
//     legacy: {
//       openHouses: urlRoot + 'open-house-api/api/v1/listings',
//       listingSummary: urlRoot + 'add-edit-media/listing/address',
//       listing: urlRoot + 'listings-api/api/v1/listing',
//       searchSuggestions: urlRoot + 'listings-api/api/v1/searchSuggestions',
//       bulkListings: urlRoot + 'listings-api/api/v1/listingsForAgent',
//       bulkListingDelete: urlRoot + 'listings-api/api/v1/listing',
//       bulkListingRecover: urlRoot + 'listings-api/api/v1/listing',
//       bulkListingCopy: urlRoot + 'listings-api/api/v1/listing',
//       bulkListingClone: urlRoot + '/add-edit-media/media/clone',
//       validation: urlRoot + 'listings-api/api/v1/validation',
//       specialValidation: urlRoot + 'listings-api/api/v1/specialValidation',
//       media: urlRoot + 'add-edit-media/media'
//     },
//     session: urlRoot + 'session-api/api/v1',
//     ramco: urlRoot + 'ramco-api',
//     impersonations: urlRoot + 'teams-api/impersonations',
//     agents: urlRoot + 'open-house-api/api/v1/agents',
//     searchSuggestions: urlRoot + 'listings-api/api/v2/search-suggestions',
//     fileSystem: '//mediadev.northstarmls.com',
//     listing: urlRoot + 'listings-api/api/v2/listings-detail',
//     upsertListings: urlRoot + 'listings-api/api/v2/listings-no-rules',
//     specialUpsertListings: urlRoot + 'listings-api/api/v2/special-edit',
//     dynamicData: urlRoot + 'listings-api/api/v2/dynamic-data',
//     genericProc: urlRoot + 'listings-api/api/v2/get-generic',
//     listingSummary: urlRoot + 'listings-api/api/v2/listings-summary',
//     listingOptions: urlRoot + 'listings-api/api/v1/listingOptions',
//     listingOptionsSearch: urlRoot + 'listings-api/api/v1/dynamicListingOptions',
//     listingRelatedFields: urlRoot + 'listings-api/api/v1/relatedFields',
//     listingAgentSearch: urlRoot + 'listings-api/api/v1/listingAgentSearch',
//     listingOperations: urlRoot + 'listings-api/api/v2',
//     openHouses: urlRoot + 'open-house-api/api/v2/open-houses',
//     media: urlRoot + 'add-edit-media/api/v2/media',
//     mediaUpload: urlRoot + 'add-edit-media/api/v2/upload',
//     mediaDisplay: '//mediadev.northstarmls.com/mediadisplay/v2',
//     help: urlRoot + 'help-api/api/v2/help',
//     history: urlRoot + 'history-api/api/v1/history',
//     autopopSearch: urlRoot + 'listings-api/api/v1/autopop',
//     autopop: urlRoot + 'listings-api/api/v2/autopopulate',
//     rprAutopop: urlRoot + 'listings-api/api/v1/rprAutopopulate',
//     taxData: urlRoot + 'listings-api/api/v2/autopop/tax-data',
//     validation: urlRoot + 'listings-api/api/v2/validate',
//     specialValidation: urlRoot + 'listings-api/api/v2/special-validate',
//     teams: urlRoot + 'teams-api',
//     preferences: urlRoot + 'session-api/api/v1/preferences',
//     uiComponents: urlRoot + 'listings-api/api/v2/application-ui-component'
//   },
//   google: {
//     analytics: {
//       trackingId: 'G-YVJJQ35ZJ6'
//     }
//   },
// };
